<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <!-- eslint-disable -->
      <v-card-text
        v-show="!!message"
        v-html="message"
      />

      <v-divider />
      <!-- eslint-enable -->
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="grey"
          text
          @click.native="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click.native="agree"
        >
          {{ $t('Yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      width: 400,
      zIndex: 200
    }
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      })
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
}
</script>